import BaseQuery from '@/components/BaseQuery'
import {BaseQueryChildrenType} from '@/components/types/BaseQueryChildrenType'
import React from 'react'
import {gql} from '@apollo/client'
import NewJobPage from '@/components/pages/NewDatasetJobPage/NewJobPage'

const query = gql`
    query DatabaseList {
        databaseList {
            database_id,
            database_name,
            version
        }
    }
`

const NewJobPageContainer = () => {
    return (
        <BaseQuery
            query={query}
            variables={{}}
            loadingMessage='Loading database list'
            notFoundMessage='Database list not found'
        >
            {({data}: BaseQueryChildrenType) => {
                return <NewJobPage databaseList={data.databaseList} />
            }}
        </BaseQuery>
    )
}

export default NewJobPageContainer